<template>
  <div
    class="game_swipe"
    :style="
      `background-image: url(https://oss.zhekoushenqi.com/data/homegameActivity/test5.png?t=${props.nowDay})`
    "
  >
    <!-- 轮播图 -->
    <div class="swiper">
      <div class="swiper-wrapper" ref="slides" @touchmove="touchAction">
        <div
          class="swiper-slide"
          v-for="(item, index) in state.swiperList"
          :key="item + index"
        >
          <img :src="item.url" alt="" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script setup>
import "swiper/swiper-bundle.min.js";
import { Swiper, Pagination, Autoplay } from "swiper";
import { onMounted, ref, reactive, nextTick, watch } from "vue";
import { detect } from "@/utils/device";
import "swiper/modules/effect-creative/effect-creative.min.css";

const state = reactive({
  swiperList: [],
  count: 0,
});

const props = defineProps({
  swiperList: {
    type: Array,
    default: () => [],
  },
  nowDay: {
    type: String,
    default: "",
  },
});
watch(props, (newVal, oldVal) => {
  // ++state.count;
  state.swiperList = newVal.swiperList;
  nextTick(() => {
    mySwiper && mySwiper.destroy();
    initSwiper();
  });
});
var mySwiper = "";
var slides = ref(null);

Swiper.use([Pagination, Autoplay]);
const initSwiper = () => {
  mySwiper = new Swiper(".swiper", {
    autoplay: {
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    initialSlide: 2,
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.5,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
    },
    // observer: true, //修改swiper自己或子元素时，自动初始化swiper
    // observeParents: true, //修改swiper的父元素时，自动初始化swiper
    // onSlideChangeEnd: function(swiper) {
    //   swiper.update();
    //   mySwiper.startAutoplay();
    //   mySwiper.reLoop();
    // },
  });
};

// 触摸事件
const touchAction = (e) => {
  if (detect() == "android" || detect() == "harmony") {
    window.JsBridge.disPatchTouchViewPager(true);
  }
};
</script>
<style scoped>
/* 轮播 */
.game_swipe {
  width: 100%;
  height: 1242px;
  background-size: 100% 100%;
  padding-top: 200px;
}
.swiper {
  /* width: 500px; */
  height: 950px;
  touch-action: pan-y pinch-zoom;
}
.swiper .swiper-wrapper {
  height: 804px;
  padding-top: 50px;
}
.game_swipe .swiper div div {
  width: 100%;
  height: 804px;
  border: 6px solid #fff;
  border-radius: 20px;
}
.swiper-slide-active {
  color: #fff;
}

.swiper-container {
  width: 100%;
  height: 100%;
}
.game_swipe .swiper-slide {
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.85);
}
.swiper-slide img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.game_swipe .swiper-slide-active,
.game_swipe .swiper-slide-duplicate-active {
  transform: scale(1.1);
}

/* 分页指示 */
.swiper-pagination {
  /* width: 50px; */
  height: 50px;
}
:deep(.swiper-pagination-bullet) {
  background-color: #f0c668;
}
:deep(.swiper-pagination-bullet-active) {
  background-color: #f0c668;
  transform: scale(1.5);
}
:deep(.swiper-pagination-lock) {
  display: block;
}
</style>
